<template>
    <dialog
        class="absolute inset-0 w-full h-full max-w-none max-h-none m-0 p-0 border-0 bg-transparent text-inherit overflow-visible flex justify-center items-center"
        :style="{ zIndex }"
        :aria-hidden="isTopmost ? undefined : 'true'"
        :aria-label="entry.ariaLabel"
        :aria-labelledby="entry.ariaLabelledBy"
        :aria-modal="isTopmost ? 'true' : undefined"
        :data-entry-id="entry.id"
        :inert="isTopmost ? undefined : true"
        data-testid="modal-panel"
        open
        tabindex="-1"
        @click.self="$emit('backdropClick')"
    >
        <div class="relative inset-0 flex justify-center items-center" @click.stop>
            <button
                type="button"
                class="absolute top-4 right-4"
                aria-label="Close"
                data-testid="modal-extra-close-button"
                @click="$emit('dismiss')"
                v-if="entry.showExtraCloseButton"
            >
                <icon class="w-6 h-6" name="regular/remove" />
            </button>
            <dynamic-entry-renderer :entry="entry" @close="$emit('entryClose')" />
        </div>
    </dialog>
</template>

<script setup lang="ts">
    /**
     * Centered dialog layer for a dynamic modal entry. It owns backdrop clicks,
     * optional container-level close control, and topmost accessibility attributes.
     */
    import DynamicEntryRenderer from '@/components/dynamicModals/DynamicEntryRenderer.vue';
    import { type ModalData } from '@/store/modules/dynamicModals/store.ts';

    interface Emits {
        (e: 'backdropClick'): void;
        (e: 'dismiss'): void;
        (e: 'entryClose'): void;
    }

    defineProps<{
        entry: ModalData;
        isTopmost: boolean;
        zIndex: string;
    }>();

    defineEmits<Emits>();
</script>
